import { BackdropClassKey } from "@material-ui/core";
import { StyleRules } from "@material-ui/core/styles";

export const MuiBackdrop: Partial<StyleRules<BackdropClassKey>> = {
  root: {
    backdropFilter: "blur(24px)",
  },
};
